// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__BbDwo","selects":"Documents_selects__2H0j7"};